var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","disabled":_vm.disabled,"outlined":"","small":""},on:{"click":_vm.candidatesZoomRegistrant}},[_vm._v("Add to Zoom webinar")])}
var staticRenderFns = []

export { render, staticRenderFns }